import React from 'react';
import Nav from '../Page Components/Nav';
import Footer from "../Page Components/Footer";
import Card from "../Co Components/SquareCards";
import Square from "../Co Components/SquareCards";
import Title from "../Co Components/Titles";
import homehero from '../assets/Images/homehero.png';
import Rectangle from "../Co Components/RectangleCards";
import LineButton from "../Co Components/LineButton";
import { useEffect } from 'react';
import PartnerCard from "../Co Components/PartnerCard";
import Resecurity from "../assets/Images/partners/Resecurity.jpg";
import dPhish from "../assets/Images/partners/dPhish.jpg";
import senhasegura from "../assets/Images/partners/senhasegura.jpg";
import partlix from "../assets/Images/partners/partlix.jpg";
import watchguard from "../assets/Images/partners/watchguard.png";
import bitdefender from "../assets/Images/partners/bitdefender.png";
import livingsecurity from "../assets/Images/partners/livingsecurity.jpeg";
import dex from "../assets/Images/partners/dexPose.png";
import cyverse from "../assets/Images/partners/cyVerse.jpg";
import zscaler from "../assets/Images/partners/zscaler.png";
import ibm from "../assets/Images/partners/IBM.png";
import malwarebytes from "../assets/Images/partners/Malwarebytes.png";
import manea from "../assets/Images/partners/manea.png";

const Tech = () => {
    useEffect(() => {
        window.scrollTo(0, 0)


    });
    return (
        <>

            <Nav />
            <Title className={''} header={"our"} body={"TECH PARTNERS"} />
            <center>
                <p className={'fs-6 Poppins  w-100'}>
                Elevate every experience with our broad ecosystem of agency, consultancy, and system<br/> integrators. We've got you covered, from end-to-end migration and implementation to ongoing<br/> strategic customer engagement support.

                </p>
            </center>

            <div className={'container mt-5 justify-content-center'}>
                {/*<center>*/}
                {/*    <p className={'fs-6 Poppins  w-100'}>*/}
                {/*        We're partnered with the world's leading agencies, consultancies, and systems integrators*/}
                {/*        <br/><br/>Explore the Possibilities Across Our Solutions Partners*/}
                {/*    </p>*/}
                {/*</center>*/}
                <div className={' mb-5 row justify-content-around '}>
                    <PartnerCard
                        to={'https://dphish.com'}
                        className={'mx-4 col-lg-4 mt-5'}
                        image={dPhish}

                    />
                    <PartnerCard
                        to={'https://www.partlix.com'}
                        className={'mx-4 pt-5 col-lg-4 mt-5'}
                        image={partlix}

                    />
                    <PartnerCard
                        to={'https://www.resecurity.com'}
                        className={'mx-4 col-lg-4 mt-5'}
                        image={Resecurity}

                    />

                    <PartnerCard
                        to={'https://senhasegura.com'}
                        className={'mx-4 col-lg-4 mt-5'}
                        image={senhasegura}

                    />
                    <PartnerCard
                        to={'https://watchguard.com'}
                        className={'mx-4 col-lg-4 mt-5'}
                        image={watchguard}

                    />
                    <PartnerCard
                        to={'https://bitdefender.com'}
                        className={'mx-4 col-lg-4 mt-5'}
                        image={bitdefender}

                    />
                    <PartnerCard
                        to={'https://livingsecurity.com'}
                        className={'mx-4 col-lg-4 mt-5'}
                        image={livingsecurity}

                    />
                    <PartnerCard
                        to={'https://dexpose.io/'}
                        className={'mx-4 col-lg-4 mt-5'}
                        image={dex}

                    />
                    <PartnerCard
                        to={'https://cy-verse.io/'}
                        className={'mx-4 col-lg-4 mt-5'}
                        image={cyverse}

                    />
                    <PartnerCard
                        to={'https://www.zscaler.com/'}
                        className={'mx-4 col-lg-4 mt-5'}
                        image={zscaler}

                    />
                    <PartnerCard
                        to={'https://www.ibm.com/security'}
                        className={'mx-4 col-lg-4 mt-5'}
                        image={ibm}

                    />
                    <PartnerCard
                        to={'https://www.malwarebytes.com/'}
                        className={'mx-4 col-lg-4 mt-5'}
                        image={malwarebytes}

                    />
                    <PartnerCard
                        to={'https://manea.ai/'}
                        className={'mx-4 col-lg-4 mt-5'}
                        image={manea}
                        maneaWidth = {true}
                        Title = {'Manea'}

                    />


                </div>
            </div>


            <Footer />
        </>
    );

}

export default Tech;